module.exports = __webpack_public_path__ + "static/media/sha1.d777ceaa.jpg";